const Types = {
  CLEAR_DATA: "CLEAR_DATA",
  SET_LEAD_SOURCES: "SET_LEAD_SOURCES",
  SET_SELLERS: "SET_SELLERS",
  SET_SELLERS_DATA: "SET_SELLERS_DATA",
};

export const state = {
  leadSources: [],
  sellers: [],
};

export const getters = {
  getLeadSources: state => state.leadSources,
  getSellers: state => state.sellers,
  getSellerById: state => id => state.sellers.find(seller => seller.id === id),
  getLeadSourceById: state => id =>
    state.leadSources.find(source => source.id === id),
  hasLeadSources: state => state.leadSources.length > 0,
  hasSellers: state => state.sellers.length > 0,
};

export const mutations = {
  [Types.CLEAR_DATA]: state => {
    state.leadSources = [];
    state.sellers = [];
  },
  [Types.SET_LEAD_SOURCES]: (state, leadSources) => {
    state.leadSources = leadSources || [];
  },
  [Types.SET_SELLERS]: (state, sellers) => {
    state.sellers = sellers || [];
  },
  [Types.SET_SELLERS_DATA]: (state, { leadSources, sellers }) => {
    state.leadSources = leadSources || [];
    state.sellers = sellers || [];
  },
};

export const actions = {
  clearData({ commit }) {
    commit(Types.CLEAR_DATA);
  },
  setLeadSources({ commit }, leadSources) {
    commit(Types.SET_LEAD_SOURCES, leadSources);
  },
  setSellers({ commit }, sellers) {
    commit(Types.SET_SELLERS, sellers);
  },
  setSellersData({ commit }, { leadSources, sellers }) {
    commit(Types.SET_SELLERS_DATA, { leadSources, sellers });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
